<template>
    <span>
        <div class="page-wrapper">
            <router-view></router-view>
        </div>
    </span>
</template>

<script>
  export default {
    name: 'EmptyLayout',
    components: {},
  }
</script>

<style scoped>
    .page-wrapper {
        margin-top: 0;
    }
</style>